var _a, _b, _c, _d, _e, _f;
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import getConfig from 'next/config';
import { getBrowser, getOS } from '@core/userAgent';
export const nowAndNowLocal = () => {
    const now = new Date();
    const nowLocal = new Date(now.valueOf() - now.getTimezoneOffset() * 60 * 1000);
    return [now, nowLocal];
};
export const nowAndNowLocalToString = () => {
    const [now, nowLocal] = nowAndNowLocal();
    return [
        now.toISOString().replace('Z', ''),
        nowLocal.toISOString().replace('Z', ''),
    ];
};
export const removeEmojis = (text) => {
    // https://www.regextester.com/106421
    // the following code removes the following characters
    // 0x00A9(copy right symbol),
    // 0x00AE(register symbol),
    // 0x1F000 - 0x1F3FF, 0x1F400 - 0x1F7FF, 0x1F800 - 0x1FBFF (various emoji, symobols and pictographs)
    return typeof text === 'string'
        ? text
            .replace(/(\u00a9|\u00ae|[\u2000-\u2BFF]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g, '')
            .trim()
        : '';
};
export const mobileOS = ['Android', 'iOS'];
export const ITPFreeUserAgents = ['Chrome', 'Firefox'];
export const extractPageUrl = (state) => {
    // Note: extractPageUrl helper is being used by both FWN and PWA to determine
    // most probable page_url passed to tracking requests. Be aware for FWN it is
    // a placement url, however for PWA it is a referrer url.
    const { params } = state || {};
    const { referrer, in_iframe, page_url } = params || {};
    if (in_iframe && referrer) {
        // value taken from referrer of an iframe
        return referrer;
    }
    return page_url;
};
export const getPixelClientMeta = () => {
    const [now] = nowAndNowLocalToString();
    return {
        browser: getBrowser(),
        client_event_time: now,
        client_upload_time: now,
        locale: typeof window !== 'undefined' ? navigator.language : undefined,
        os_name: getOS(),
        platform: process.env.PLATFORM,
        product: process.env.PRODUCT,
        product_version: process.env.PRODUCT_VERSION,
        track_version: process.env.TRACK_VERSION,
    };
};
/** @deprecated use @core/logging `logMessage()` instead. */
export const logInfo = (...args) => {
    // eslint-disable-next-line
    console.info('FWN:', ...args);
};
export const logWarning = (...args) => {
    // eslint-disable-next-line
    console.warn('FWN:', ...args);
};
export const getVideoPoster = (video) => {
    if (!video || !Array.isArray(video.video_posters)) {
        return '';
    }
    const jpgPosters = video === null || video === void 0 ? void 0 : video.video_posters.filter((poster) => poster.format === 'jpg');
    if (jpgPosters.length > 0) {
        return jpgPosters[0].url;
    }
    return video === null || video === void 0 ? void 0 : video.thumbnail_url;
};
export const getVideoPlaceholder = (video) => {
    var _a;
    if (!video) {
        return '';
    }
    if (!Array.isArray(video.video_files) || video.video_files.length === 0) {
        return getVideoPoster(video);
    }
    return ((_a = video.video_files[0]) === null || _a === void 0 ? void 0 : _a.placeholder_url) || getVideoPoster(video);
};
export const getVideoBlurhash = (video) => {
    var _a;
    if (!video) {
        return '';
    }
    if (!Array.isArray(video.video_files) || video.video_files.length === 0) {
        return '';
    }
    return ((_a = video.video_files[0]) === null || _a === void 0 ? void 0 : _a.placeholder_blur_hash) || '';
};
/** Remove any values from object based on predicate */
const REMOVE = '--remove--';
export const filterObject = (obj, predicate) => isPlainObject(obj)
    ? Object.fromEntries(Object.entries(obj)
        .map(([key, value]) => [key, filterObject(value, predicate)])
        .filter(([, value]) => value !== REMOVE))
    : isArray(obj)
        ? obj.map((o) => filterObject(o, predicate)).filter((v) => v !== REMOVE)
        : predicate(obj)
            ? obj
            : REMOVE;
/** Remove unserializable values from object using JSON */
export const filterUnserializable = (obj) => JSON.parse(JSON.stringify(obj));
/**
 * @returns The object representation of the URL search params.
 */
export const searchParams = () => {
    const results = {};
    try {
        const params = new URLSearchParams(window.location.search);
        for (const [key, value] of params) {
            results[key] = value;
        }
    }
    catch (e) {
        // CS-84: URLSearchParams is a non-iterable instance in legacy Chrome.
        // Ignore URL Widget params when this error is caught.
    }
    return results;
};
/**
 * Local storage key used to indicate browser is in "debug" mode
 */
export const DEBUG_KEY = 'fwdebug';
let isDebugCache;
/**
 * @returns Whether the code is in debug environment. It can be decided either
 * by the env variable or `fwdebug` URL search param (i.e fw.tv?fwdebug=1)
 */
export const isDebug = () => {
    if (isDebugCache !== undefined) {
        return isDebugCache;
    }
    if (process.env.NODE_ENV === 'development') {
        return true;
    }
    try {
        return !!window.localStorage.getItem(DEBUG_KEY);
    }
    catch (_a) {
        return false;
    }
};
export const defaultApiHost = (_c = (_a = process.env.API_HOST) !== null && _a !== void 0 ? _a : (_b = getConfig()) === null || _b === void 0 ? void 0 : _b.publicRuntimeConfig.apiHost) !== null && _c !== void 0 ? _c : '';
export const defaultStripePublishableKey = (_f = (_d = process.env.STRIPE_PUBLISHABLE_KEY) !== null && _d !== void 0 ? _d : (_e = getConfig()) === null || _e === void 0 ? void 0 : _e.publicRuntimeConfig.stripePublishableKey) !== null && _f !== void 0 ? _f : 'pk_test_51IGU4HHvdCSG50mtan9SFMcC0IMks0sGlRsBwc6MgNjmnV6fg8uWjWdqiiRHvWcRm3XsSv8zCfCBW7ULffu3fRIf00pb9LB42y';
